var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandHipchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brand-hipchat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.3538C2 6.38186 6.62365 2.58984 12.002 2.58984C17.3788 2.58984 22 6.38226 22 11.3538C22 13.816 20.8494 16.011 19.0428 17.582C19.3081 18.0466 19.6736 18.5572 19.993 18.9489C19.9995 18.9568 20.0058 18.9648 20.012 18.973C20.3382 19.399 20.5139 20.0243 20.2038 20.6159C19.9037 21.1883 19.3138 21.4088 18.804 21.4088C17.0807 21.4088 15.1986 20.7521 13.8282 19.9321C13.0177 19.9765 12.4042 19.9998 12 19.9998C6.64277 19.9998 2 16.3459 2 11.3538ZM17.2216 16.4775L17.2291 16.4721L17.2629 16.4474C17.2928 16.4253 17.3373 16.3922 17.3925 16.35C19.0257 15.0863 20 13.299 20 11.3538C20 7.75343 16.5612 4.58984 12.002 4.58984C7.44035 4.58984 4 7.75383 4 11.3538C4 14.9378 7.41723 17.9998 12 17.9998C12.3926 17.9998 13.0635 17.9734 14.0302 17.9175C14.243 17.9052 14.4541 17.9612 14.6328 18.0773C15.4964 18.6384 16.6582 19.1148 17.7705 19.3119C17.4089 18.7825 17.0526 18.1749 16.8587 17.6237C16.711 17.2038 16.8585 16.7369 17.2207 16.4781L17.2216 16.4775ZM6.79289 12.7929C7.18342 12.4024 7.81658 12.4024 8.20711 12.7929C10.3166 14.9024 13.6834 14.9024 15.7929 12.7929C16.1834 12.4024 16.8166 12.4024 17.2071 12.7929C17.5976 13.1834 17.5976 13.8166 17.2071 14.2071C14.3166 17.0976 9.68342 17.0976 6.79289 14.2071C6.40237 13.8166 6.40237 13.1834 6.79289 12.7929Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandHipchat);
export default __webpack_public_path__ + "static/media/brand-hipchat.83371b986ee01895b5027af522d40747.svg";
export { ForwardRef as ReactComponent };